// shared/formly-fields/formly-field-primeng-select.component.ts
import { Component } from '@angular/core';
import { FormControl } from '@angular/forms'; // Importa FormControl
import { FieldType, FieldTypeConfig } from '@ngx-formly/core'; // Importa FieldTypeConfig
import { isObservable, map, of } from 'rxjs'; // Per gestire le opzioni come Observable

@Component({
    selector: 'formly-field-primeng-select',
    styleUrls: ['../../config-page/config-page.component.scss'],
    template: `
   <div class="formly-primeng-select mt20 mB10"> <strong><label class="form-label">{{ to.label }}</label></strong>
        <br>
        <p-dropdown
            [formControl]="formControlTyped"       [options]="(options$ | async) ?? []"     [optionLabel]="to.optionLabel || 'label'" [optionValue]="to.optionValue || 'value'" [formlyAttributes]="field"             [placeholder]="placeholder"          [filter]="filter"                    [showClear]="showClear"              appendTo="body">                     </p-dropdown>
    </div>
    <p-divider></p-divider>`
})

export class FieldPrimengSelectComponent extends FieldType {

    get formControlTyped(): FormControl {
        return this.formControl as FormControl;
    }

    get options$() {
        const opts = this.to.options;
        return isObservable(opts)
            ? opts.pipe(map((options: any[] | null) => options ?? []))
            : of(opts ?? []);
    }

    get placeholder() {
        return this.to.placeholder ?? '';
    }

    get filter() {
        return this.to.filter ?? false;
    }

    get showClear() {
        return this.to.showClear ?? false;
    }
}